import { Loadable } from 'jotai/vanilla/utils/loadable'

export const isLoadableError = <T>(
  s: Loadable<T>,
): s is Extract<Loadable<T>, { state: 'hasError' }> => s.state === 'hasError'

export const isLoadableLoading = <T>(
  s: Loadable<T>,
): s is Extract<Loadable<T>, { state: 'loading' }> => s.state === 'loading'

export const isLoadableData = <T>(
  s: Loadable<T>,
): s is Extract<Loadable<T>, { state: 'hasData' }> => s.state === 'hasData'
